import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Meetings from "./meetings";
import { getMeetingList } from "services/redux/installation/meetings/action"

const mapStateToProps = (state) => ({
  meetingList: state.meetingReducer.meetingList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getMeetingList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Meetings);
